module.exports = __webpack_public_path__ + "img/logo.2bf0cf66.svg";